import React from "react";
import { Ticket, CreditCard, Award } from "lucide-react";

export default function HowItWorks() {
  const steps = [
    { icon: <Ticket className="w-6 h-6" />, title: "Escolha sua rifa", desc: "Explore as rifas ativas e selecione a quantidade de cotas desejada." },
    { icon: <CreditCard className="w-6 h-6" />, title: "Pague com PIX", desc: "Confirmação instantânea via QR Code ou copia e cola." },
    { icon: <Award className="w-6 h-6" />, title: "Concorra ao sorteio", desc: "Sorteio transparente pela Loteria Federal na data anunciada." },
  ];

  return (
    <div className="max-w-5xl mx-auto px-6 py-16">
      <div className="text-center mb-14">
        <p className="text-xs uppercase tracking-[0.3em] text-amber-200/80 mb-2">Como funciona</p>
        <h1 className="heading text-3xl sm:text-5xl font-extrabold text-slate-50">3 passos para <span className="gold-gradient-text">concorrer</span></h1>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {steps.map((s, i) => (
          <div key={i} className="card-luxury rounded-2xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-12 h-12 rounded-xl gold-btn flex items-center justify-center">{s.icon}</span>
              <span className="text-4xl heading font-black text-slate-800">0{i + 1}</span>
            </div>
            <h3 className="heading text-xl font-bold text-slate-50 mb-2">{s.title}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
